import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import loadWishListIfNeeded from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListIfNeeded";
import updateLoadWishListLinesParameter from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateLoadWishListLinesParameter";

type Parameter = {
    wishListId: string;
};

type HandlerType = Handler<Parameter>;

export const ResetWishListLinesData: HandlerType = props => {
    props.dispatch({
        type: "Data/WishListLines/Reset",
    });
};

export const AddCacheBuster: HandlerType = props => {
    props.dispatch(
        updateLoadWishListLinesParameter({
            additionalQueryStringParameters: {
                _: `${Date.now()}`,
            },
        }),
    );
};

export const ReloadWishList: HandlerType = props => {
    props.dispatch(
        loadWishListIfNeeded({
            wishListId: props.parameter.wishListId,
            keepLinesParameter: true,
        }),
    );
};

export const chain = [ResetWishListLinesData, AddCacheBuster, ReloadWishList];

const refreshWishList = createHandlerChainRunner(chain, "RefreshWishList");
export default refreshWishList;